export default {
  heroEyebrow: 'Solutions for teams',
  heroTitle: 'Digital employees built around your team’s processes',
  heroBody:
    'Laplace helps you identify repeatable work, create human-controlled AI agents with the right context and tools, and embed them into daily operations.',
  heroImageAlt:
    'Laplace digital employee selector with document analysis, documentation, sprint planning and task analytics roles',

  departmentSalesTitle: 'Sales',
  departmentSalesBody:
    'Bring deal context together, prepare for meetings and recommend the next step.',
  departmentSupportTitle: 'Customer Support',
  departmentSupportBody:
    'Find source-backed answers, prepare resolutions and escalate non-standard requests to a person.',
  departmentMarketingTitle: 'Marketing & Content',
  departmentMarketingBody:
    'Gather inputs from tasks and documents, then prepare briefs and drafts in your brand context.',
  departmentEngineeringTitle: 'Engineering',
  departmentEngineeringBody:
    'Check release readiness, identify blockers and connect tasks, documentation and code changes.',
  departmentDataTitle: 'Data & Analytics',
  departmentDataBody:
    'Bring definitions and findings together from available reports and documents with source links.',
  departmentKnowledgeTitle: 'Knowledge',
  departmentKnowledgeBody:
    'Answer from company documents, translate context for each role and show the underlying sources.',
  departmentItTitle: 'IT',
  departmentItBody:
    'Triage common requests, find instructions and prepare permitted actions for review.',
  departmentLegalTitle: 'Legal',
  departmentLegalBody:
    'Find relevant clauses in contracts and policies and prepare materials for specialist review.',
  departmentPeopleTitle: 'People',
  departmentPeopleBody:
    'Support onboarding, answer policy questions and prepare repeatable People operations.',
  departmentProductivityTitle: 'Operations',
  departmentProductivityBody:
    'Run repeatable tasks on a schedule, collect the result and hand exceptions back to a person.',

  exampleEyebrow: 'Workflow · Engineering',
  exampleTitle: 'A digital employee coordinates release readiness',
  exampleBody:
    'On demand or on a schedule, the agent gathers status from Jira, Confluence and GitHub, highlights blockers and backs every conclusion with source links.',
  exampleAsksLabel: 'An employee asks',
  exampleQuestion: 'Check release readiness and show me the blockers',
  exampleAnswersLabel: 'Laplace answers',
  exampleAnswer:
    'The release is close to ready. I found 3 items that need attention:',
  exampleTask1Key: 'LP-216',
  exampleTask1Title: 'A critical bug is still in progress',
  exampleTask2Key: 'DOC',
  exampleTask2Title: 'Release documentation is out of date',
  exampleTask3Key: 'PR #184',
  exampleTask3Title: 'Changes are waiting for review',
  exampleSource: 'Jira · Confluence · GitHub',

  faqEyebrow: 'Common questions',
  faqTitle: 'What this gives you, and how it differs from a regular AI chat',

  faqVsChatQuestion: 'How is this different from ChatGPT or Claude?',
  faqVsChatAnswer:
    'A chat answers based on what you paste into it. Laplace works inside your systems: it finds what it needs in Jira, Confluence, GitHub and mail, and can act there — create an issue, update a page, send an email. Every change goes through confirmation, and every action leaves a record.',

  faqAlreadyHaveChatQuestion:
    'We already have a company AI chat. Why another tool?',
  faqAlreadyHaveChatAnswer:
    "A chat belongs to one person and starts every conversation from scratch. Laplace is configured per workspace: an admin connects the sources once and the whole team works from the same context. What the agent did is visible in a shared log, not buried in one employee's private chat history.",

  faqWritesQuestion: 'What can the agent change in our systems?',
  faqWritesAnswer:
    'It can read freely — search issues, documents, discussions. Anything that changes data works differently: creating an issue, editing a page, changing a status or sending an email requires confirmation. You see exactly what will be done before it happens, and you can reject it.',

  faqAccessQuestion: 'How do we limit what the agent can reach?',
  faqAccessAnswer:
    'The agent only sees systems an admin has connected to the workspace. A source that is not connected does not exist for it, and it cannot cite data it has no access to. Roles decide who configures integrations and who runs agents.',

  faqDataQuestion: 'Where is our data processed?',
  faqDataAnswer:
    "Actions in your internal systems can run through the Private Connector: it sits inside your perimeter and dials out on its own, so you open no inbound ports. Language model processing happens on the model provider's side. We will walk through the exact setup for your requirements during the demo.",

  faqStartQuestion: 'How do we start?',
  faqStartAnswer:
    'With one process. In the demo we work out which repeatable work costs your team the most time, what needs connecting, how to scope the agent, and launch one measurable scenario.',

  ctaTitle: 'Let’s find the first process for your digital employee',
  ctaBody:
    'We’ll show you how to connect your systems, define the agent’s boundaries and launch a measurable workflow.',
  ctaButton: 'Request a demo',
}
